import { SURVEY_STATUS } from '../enums/survey-status.enum';

export interface Survey {
    id: string;
    status: SURVEY_STATUS;
    startDate: Date;
    endDate?: Date;
    createdAt: Date;
    updatedAt: Date;
    createdBy: string;
    updatedBy: string;
}
